import { Component, componentMixin } from '@resn/gozer-core/component';
import { simpleMaterial, simplePlaneGeometry } from '@resn/gozer-three/simple-three';
import ThreeObjectMixin from '@resn/gozer-core-mixins/three-object';
import { Mesh, MeshBasicMaterial } from 'three';

@componentMixin(ThreeObjectMixin)
class Background extends Component {
    static materialMask = new MeshBasicMaterial({ colorWrite: false });

    options = {
        renderOrder: 1,
    };

    props = {};

    async onSetup() {
        const { renderOrder } = this.options;

        const materialMask = Background.materialMask;
        this.maskTop = new Mesh(simplePlaneGeometry, materialMask);
        this.maskTop.renderOrder = renderOrder;
        this.maskTop.position.z = 1;
        this.maskTop.position.y = 1;

        this.maskBottom = new Mesh(simplePlaneGeometry, materialMask);
        this.maskBottom.renderOrder = renderOrder;
        this.maskBottom.position.z = 1;
        this.maskBottom.position.y = -1;

        this.maskQuad = new Mesh(simplePlaneGeometry, simpleMaterial(this.props.c));
        this.maskQuad.add(this.maskTop);
        this.maskQuad.add(this.maskBottom);

        this.object.add(this.maskQuad);
    }

    set y(y) {
        this.object.position.y = y;
    }

    setSize({ width, height }) {
        this.maskQuad.scale.set(width, height, 1);
    }
}
export default Background;
